import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Module } from '../models';
import { PaginationParams } from '../types';

export const modulesActions = createActionGroup({
    source: 'Modules',
    events: {
        'Get Modules': props<{ value: PaginationParams }>(),
        'Get Modules Success': props<{ payload: Module[]; total: number }>(),
        'Get Modules Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
